export default __webpack_public_path__ + "resources/icons/n100-c9cc.png";